import { useTranslation } from "react-i18next";
import { UseFormReturn } from "react-hook-form";
import { Input } from "~/components/ui/input";

import { Label } from "~/components/ui/label";
import { SignUpSchemaType } from "~/pages/contact-us/utils";
import { CategorySelect } from "./category-select";
import { ISBNField } from "./isbn-field";
import { MessageField } from "./message-field";

interface FormFieldsProps {
  formMethods: UseFormReturn<SignUpSchemaType>;
  isLoggedIn?: boolean;
}

export const FormFields = ({ formMethods, isLoggedIn }: FormFieldsProps) => {
  const { t } = useTranslation(["contactUs"]);
  // Fields subscribe to form state themselves (useFormState/useWatch): with
  // React Compiler the parent's re-render no longer cascades down, so reading
  // formMethods.formState here would go stale.
  const { register, control } = formMethods;

  return (
    <>
      <div className="grid grid-cols-2 gap-8">
        <div className="space-y-2">
          <Label className="text-sm">{t("contactUs:form.name.label")}</Label>
          <Input
            placeholder={t("contactUs:form.name.placeholder")}
            className="rounded-lg h-12"
            {...register("name")}
            disabled={isLoggedIn}
          />
        </div>
        <div className="space-y-2">
          <Label className="text-sm">{t("contactUs:form.email.label")}</Label>
          <Input
            placeholder={t("contactUs:form.email.placeholder")}
            {...register("email")}
            className="rounded-lg h-12"
            disabled={isLoggedIn}
          />
        </div>
        <CategorySelect control={control} />
        <ISBNField register={register} control={control} />
      </div>
      <MessageField register={register} control={control} />
    </>
  );
};
